import clsx from 'clsx'
import React from 'react'

import { ListItemGroupProps } from './type'

export const ListItemGroup = ({ children }: ListItemGroupProps) => {
  return <ul className={clsx('tw-w-full')}>{children}</ul>
}
